/**
 * @author sgdh
 * 功能：枚举转换
 */

import * as ENUM from '@/enum'
export type SelectTypeTm = {
  label: string
  value: string | number
  disabled?: boolean
  color?: string
  children?: SelectTypeTm[]
}

// 模块类型
type EnumModuleKeyType = keyof typeof ENUM
// 各模块枚举名称类型
type EnumMapKeyType<K extends EnumModuleKeyType> = keyof (typeof ENUM)[K]
// 各模块枚举类型
type enumValueType<K extends EnumModuleKeyType, M extends EnumMapKeyType<K>> = (typeof ENUM)[K][M]
// 各模块每个枚举每个键的类型  TODO待定
// type ResKeys<T> = T extends object ? keyof T : never;
// type ResKeyType<K extends EnumModuleKeyType, M extends EnumMapKeyType<K>> = ResKeys<enumValueType<K, M>>;

// 枚举转map
export const enumToMap = <K extends EnumModuleKeyType, M extends EnumMapKeyType<K>>(EnumCategory: K, EnumName: M) => {
  const mapValue: enumValueType<K, M> = ENUM[EnumCategory][EnumName]
  const mapName: enumValueType<K, M> = ENUM[EnumCategory][typeof EnumName == 'string' ? ((EnumName + 'Name') as M) : EnumName]
  if (mapValue && mapName) {
    // TODO 层级套的太深了 这里先临时这么处理下 后面再优化
    const returnMap: TCommon.CommunalType = {}
    for (const key in mapValue) {
      if (Object.prototype.hasOwnProperty.call(mapValue, key)) {
        if (mapName[key]) {
          returnMap[mapValue[key]] = mapName[key]
        }
      }
    }
    return returnMap
  }
  return {}
}

// 枚举名称转数值
export const enumToNameMap = <K extends EnumModuleKeyType, M extends EnumMapKeyType<K>>(EnumCategory: K, EnumName: M) => {
  const mapValue: enumValueType<K, M> = ENUM[EnumCategory][EnumName]
  const mapName: enumValueType<K, M> = ENUM[EnumCategory][typeof EnumName == 'string' ? ((EnumName + 'Name') as M) : EnumName]
  if (mapValue && mapName) {
    // TODO 层级套的太深了 这里先临时这么处理下 后面再优化
    const result: TCommon.CommunalType = {}
    for (const key in mapName) {
      if (Object.prototype.hasOwnProperty.call(mapName, key)) {
        if (mapValue[key] && typeof mapName[key] === 'string') {
          result[mapName[key]] = mapValue[key]
        }
      }
    }
    return result
  }
  return {}
}

/**
 * 枚举转成下拉框格式 {disabled : false,label : "草稿",value : 0,}
 * @param EnumCategory
 * @param EnumName
 * @return [{disabled : false,label : "草稿",value : 0,, color: ''}]
 */
export const enumToOption = <K extends EnumModuleKeyType, M extends EnumMapKeyType<K>>(EnumCategory: K, EnumName: M): SelectTypeTm[] => {
  const optionValue: enumValueType<K, M> = ENUM[EnumCategory][EnumName]
  const optionLabel: enumValueType<K, M> = ENUM[EnumCategory][typeof EnumName == 'string' ? ((EnumName + 'Name') as M) : EnumName]
  const optionColor: enumValueType<K, M> = ENUM[EnumCategory][typeof EnumName == 'string' ? ((EnumName + 'Color') as M) : EnumName]
  if (optionValue && optionLabel) {
    const returnOption = []
    for (const key in optionValue) {
      const optionItem: SelectTypeTm = {
        label: '',
        value: '',
        disabled: false,
        color: '',
      }
      if (Object.prototype.hasOwnProperty.call(optionValue, key)) {
        if (optionLabel[key]) {
          optionItem.value = optionValue[key] as string | number
          optionItem.label = optionLabel[key] as string
          optionItem.disabled = false
          if (optionColor) {
            optionItem.color = optionColor[key] as string
          }
          returnOption.push(optionItem)
        }
      }
    }
    return returnOption
  }
  return []
}

// 转换枚举为list
export const enumToListV = (data: TCommon.Json): SelectTypeTm[] => {
  const regExpValue = /\d+/
  if (data) {
    const returnOption = []
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const item = data[key]
        if (regExpValue.test(item)) {
          returnOption.push({ label: key, value: item, disabled: false })
        }
      }
    }
    return returnOption
  }
  return []
}

export const enumToListV2 = (data: TCommon.Json): SelectTypeTm[] => {
  const regExpValue = /\d+/
  if (data) {
    const returnOption = []
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const item = data[key]
        returnOption.push({ label: key, value: item, disabled: false })
      }
    }
    return returnOption
  }
  return []
}
